import React from 'react'

import { Actions, State } from './types'

const stateCtx = React.createContext([] as State)
const dispatchCtx = React.createContext((() => 0) as React.Dispatch<Actions>)

function reducer(state: State, action: Actions) {
  switch (action.type) {
    case '@snackbar/QUEUE':
      return [...state, action.id]
    case '@snackbar/DEQUEUE': {
      return state.filter(id => id !== action.id)
    }
    default:
      break
  }
  return state
}

interface Props {
  children: React.ReactNode
}

export function SnackbarProvider({ children }: Props) {
  const [state, dispatch] = React.useReducer(reducer, [])

  return (
    <dispatchCtx.Provider value={dispatch}>
      <stateCtx.Provider value={state}>{children}</stateCtx.Provider>
    </dispatchCtx.Provider>
  )
}

export function useNextOnQueue(id: string) {
  const state = React.useContext(stateCtx)

  return state[0] === id
}

export function useQueue() {
  const dispatch = React.useContext(dispatchCtx)

  return function queue(id: string) {
    dispatch({
      type: '@snackbar/QUEUE',
      id,
    })
  }
}

export function useDequeue() {
  const dispatch = React.useContext(dispatchCtx)

  return function dequeue(id: string) {
    dispatch({
      type: '@snackbar/DEQUEUE',
      id,
    })
  }
}
